'use client';

import { AlertTriangle, RefreshCw } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { useReportRouteError } from '@/lib/client/observability/use-report-route-error';

export default function MenuSegmentError({ error }: { error: Error & { digest?: string } }) {
  const pathname = usePathname();

  useReportRouteError(error, { route: pathname });

  useEffect(() => {
    console.error('[m] public menu route error', error);
  }, [error]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-b from-[var(--color-neutral)] to-white px-6">
      <div className="mx-auto max-w-sm space-y-6 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-warning)]">
          <AlertTriangle className="h-8 w-8 text-[var(--color-warning)]" />
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-bold text-[var(--color-neutral)]">
            Menu temporarily unavailable
          </h1>
          <p className="text-sm text-[var(--color-neutral)]">
            We couldn&apos;t load this menu right now. This is usually a temporary issue.
          </p>
        </div>
        <Button
          onClick={() => window.location.reload()}
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Try again
        </Button>
        <p className="text-xs text-[var(--color-neutral)]">
          If the problem persists, please let a staff member know.
        </p>
      </div>
    </div>
  );
}
